// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-sszyxfpay-__index__page_pay"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/sszyxfpay/index.css
// module id = 1576
// module chunks = 0